import React from 'react';
import { useParams } from 'react-router-dom';

export default function TilesDeliveryOrder() {
  const deliveryOrderId = useParams().id;
  const url = `https://rlugroup.in/pdf/convert?fileName=rlugroup-tiles-delivery-order.hbs&id_field=doNumber&format=A5&margintop=0.2cm&url=${process.env.REACT_APP_API_BASE_URL}/tiles/delivery-orders/details/${deliveryOrderId}`;
  
  return (
    <object 
      data={url} 
      type="application/pdf" 
      width="100%" 
      height={window.innerHeight} 
      aria-label="Tiles Delivery Order PDF"
    >
      Tiles Delivery Order PDF
    </object>
  );
}
